'use client';

import React from 'react';

import Link from 'next/link';

const HomeHero = () => {
    return (
        <section className="hero home-hero technology-herosection relative aiml-hero-section aiml-banner-video">
            <div className="absolute inset-0 z-0">
                <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                    <source src="media/bg-ai-ml.mp4" type="video/mp4" />
                </video>

                {/* Gradient Overlay */}
                <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
            </div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="text-center lg:col-span-10 lg:col-start-2 grid">
                        <div className="inline-flex flex-col lg:items-center gap-4 hero-content justify-center h-full">
                            <div className="flex sm:gap-[7px] md:gap-[25px] justify-center">
                                <img
                                    src="/img/ic-iso-white.svg"
                                    alt="project image"
                                    width={85}
                                    height={85}
                                    className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                                />
                                <img
                                    src="/img/ic-cmmi-white.svg"
                                    alt="project image"
                                    width={85}
                                    height={85}
                                    className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                                />

                                <img
                                    src="/img/ic-industry-white.svg"
                                    alt="project image"
                                    className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                                />
                                <img
                                    src="/img/ic-project-white.svg"
                                    alt="project image"
                                    className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                                />
                            </div>
                            <h1 className="mb-0 text-white">
                                Engineering Future-Ready Software,
                                <br />
                                <span className="gradient-text">AI Systems and Enterprise-Scale Platforms</span>
                            </h1>
                            <p className=" mb-0 font-normal text-xl sm:text-base md:text-xl text-white">
                                We enable smarter use of AI across the business, drive operational efficiency through automation,
                                build secure and scalable systems for enterprises, and help startups develop market-ready
                                products.
                            </p>

                            <Link href="/contact-us" className="btn btn-gradient-border self-center">
                                Connect with Us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeHero;
